import styled from "styled-components";

export const StyledH3 = styled("h3")`
    font-weight: 400;
    line-height: 1.5em;
`